import { DeliveryType } from '@/types/Address'
import { Cart } from '@/types/Cart'

import { getUUID } from '@/utils/id'

export const emptyCart: Cart = {
    cart_id: getUUID(),
    menu_id: '',
    instance_id: null,
    instance_name: null,
    fulfillment_type: DeliveryType.delivery,
    items: [],
    order_success: null,
}
